import React from 'react';
import { Link } from 'components/link/Link';

import s from './List.scss';

interface IProps {
  heading?: string;
  text: string | React.ReactNode;
  footer?: string;
  link?: string;
}

export const ListItem = ({ heading, text, footer, link }: IProps) => {
  const Container = Boolean(link) ? Link : React.Fragment;
  const containerProps = link ? { className: s.listItem__link, to: link } : {};

  return (
    <div className={s.listItem}>
      <Container {...containerProps}>
        {heading && <h3 className={s.listItem__heading}>{heading}</h3>}
        <div className={s.listItem__text}>{text}</div>
        {footer && <footer className={s.listItem__footer}>{footer}</footer>}
      </Container>
    </div>
  );
};
